export const PTSD = 
{
    Metadata:{Name:'PCL-C',maxColumn:5,numRows:17},
    Sections:
    [
        {
            Headers:[
                "Please read each one carefully, check the box that indicates how much you have " +
                "been bothered by that problem <span class='importantText'>in the last month</span>",
                "Not at all",
                "A little bit",
                "Moderately",
                "Quite a bit",
                "Extremely"
            ],
            Questions:[
                {
                    Prompt:"1. Repeated disturbing memories, thoughts, or images from a stressful experience in the past",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"}
                    ]
                },
                {
                    Prompt:"2. Repeated disturbing dreams of a stressful experience from the past.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"}
                    ]
                },
                {
                    Prompt:"3. Suddenly acting or feeling as though a stressful experience were happening again. (as if you were reliving it)",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"}
                    ]
                },
                {
                    Prompt:"4. Feeling very upset when something reminded you of a stressful experience from the past.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"}
                    ]
                },
                {
                    Prompt:"5. Having physical reactions (e.g. heart pounding, trouble breathing, sweating, etc.) when something reminded you of a stressful experience from the past",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"}
                    ]
                },
                {
                    Prompt:"6. Avoid thinking about or talking about a stressful experience from the past to avoid having feelings related to it.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"}
                    ]
                },
                {
                    Prompt:"7. Avoid activities or situations because they remind you of a stressful experience from the past.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"}
                    ]
                },
                {
                    Prompt:"8. Trouble remembering important parts of a stressful experience from the past.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"}
                    ]
                },
                {
                    Prompt:"9. Loss of interest in things you used to enjoy.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"}
                    ]
                },
                {
                    Prompt:"10. Feeling distant or cut off from other people.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"}
                    ]
                },
                {
                    Prompt:"11. Feeling emotionally numb or being unable to have loving feelings for those close to you.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"}
                    ]
                },
                {
                    Prompt:"12. Feeling as though your future will somehow be cut short.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"}
                    ]
                },
                {
                    Prompt:"13. Trouble falling or staying asleep.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"}
                    ]
                },
                {
                    Prompt:"14. Feeling irritable or having angry outbursts.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"}
                    ]
                },
                {
                    Prompt:"15. Having difficulty concentrating.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"}
                    ]
                },
                {
                    Prompt:'16. Being "super-alert" or watchful on guard.',
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"}
                    ]
                },
                {
                    Prompt:"17. Feeling jumpy or easily startled.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"}
                    ]
                },
            ]
        }
    ]
}